export default {
  computed: {
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
  },
};
